import { render, staticRenderFns } from "./KdmSimulation.vue?vue&type=template&id=b0f45c04&scoped=true&"
import script from "./KdmSimulation.vue?vue&type=script&lang=js&"
export * from "./KdmSimulation.vue?vue&type=script&lang=js&"
import style0 from "./KdmSimulation.vue?vue&type=style&index=0&id=b0f45c04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0f45c04",
  null
  
)

export default component.exports